import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createMarketplaceItem, CreateMarketplaceItemParams} from '../api';
import {QUERY__MARKETPLACE_ITEMS} from '../queryKeys';

export const useCreateMarketplaceItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateMarketplaceItemParams) =>
      createMarketplaceItem(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__MARKETPLACE_ITEMS],
      });
    },
  });
};
